// frontend/src/components/MlExperiment/MlExperimentSelector.tsx

import React from 'react';

interface Props {
  experiments: any[];
  selectedExperiment: any | null;
  onSelect: (experiment: any) => void;
  loading: boolean;
}

export const MlExperimentSelector: React.FC<Props> = ({
  experiments,
  selectedExperiment,
  onSelect,
  loading,
}) => {
  if (loading && experiments.length === 0) {
    return (
      <div style={{ color: '#8899aa', padding: '20px' }}>
        Carregando experimentos ML...
      </div>
    );
  }

  if (experiments.length === 0) {
    return (
      <div style={{ color: '#8899aa', padding: '20px', textAlign: 'center' }}>
        Nenhum experimento ML disponível
      </div>
    );
  }

  const formatDate = (dateStr: string) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getDecisionColor = (decision: string) => {
    return decision === 'APPROVED' ? '#66bb6a' : '#ef5350';
  };

  return (
    <div style={{ marginBottom: '24px' }}>
      <h3 style={{ color: '#4fc3f7', marginBottom: '12px' }}>
        📂 Selecione um Experimento ML
      </h3>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '12px'
      }}>
        {experiments.map((experiment) => (
          <div
            key={experiment.id}
            onClick={() => onSelect(experiment)}
            style={{
              background: selectedExperiment?.id === experiment.id
                ? 'rgba(79, 195, 247, 0.15)'
                : 'rgba(15, 42, 74, 0.4)',
              borderRadius: '8px',
              padding: '12px 16px',
              border: selectedExperiment?.id === experiment.id
                ? '1px solid #4fc3f7'
                : '1px solid transparent',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              if (selectedExperiment?.id !== experiment.id) {
                e.currentTarget.style.borderColor = '#1a4a7a';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedExperiment?.id !== experiment.id) {
                e.currentTarget.style.borderColor = 'transparent';
              }
            }}
          >
            <div style={{ fontWeight: 600, color: '#4fc3f7' }}>
              {experiment.experiment_id}
            </div>
            <div style={{ fontSize: '11px', color: '#8899aa', fontFamily: 'monospace', marginTop: '2px' }}>
              trace_id: {experiment.trace_id}
            </div>
            <div style={{ fontSize: '13px', color: '#8899aa', marginTop: '4px' }}>
              📊 {experiment.dataset_name} · 
              🎯 {experiment.problem_type}
            </div>
            <div style={{ fontSize: '13px', color: '#8899aa', marginTop: '2px' }}>
              📈 {experiment.strategy_name} · 
              {experiment.metric_name}: {experiment.metric_value.toFixed(4)}
            </div>
            <div style={{ marginTop: '6px' }}>
              <span style={{
                display: 'inline-block',
                padding: '2px 12px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: 600,
                background: experiment.decision === 'APPROVED' 
                  ? 'rgba(102, 187, 106, 0.15)' 
                  : 'rgba(239, 83, 80, 0.15)',
                color: getDecisionColor(experiment.decision)
              }}>
                {experiment.decision}
              </span>
            </div>
            <div style={{ fontSize: '11px', color: '#556677', marginTop: '4px' }}>
              {formatDate(experiment.created_at)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};